import bg from './bg';
import en from './en';

export type Language = 'bg' | 'en';

export const SUPPORTED_LANGUAGES: { code: Language; label: string; flag: string }[] = [
  { code: 'bg', label: 'Български', flag: '🇧🇬' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
];

export const DEFAULT_LANGUAGE: Language = 'bg';

const translations = { bg, en };

export function getTranslations(lang: Language = DEFAULT_LANGUAGE) {
  return translations[lang] || translations.bg;
}

export function getGenderedAdj(
  key: keyof typeof bg.grammar.adjectives,
  gender: 'male' | 'female',
  lang: Language = 'bg'
): string {
  const t = getTranslations(lang);
  const adj = t.grammar.adjectives[key];
  return adj ? adj[gender] : '';
}

export function getCityPreposition(cityId: string, lang: Language = 'bg'): string {
  const t = getTranslations(lang);
  return t.grammar.inCity[cityId as keyof typeof t.grammar.inCity] || `в ${cityId}`;
}

export default getTranslations;
